import { Session } from '@ais-ui/auth';

export interface TargetListParams {
  startIndex?: number;
  targetsPerPage?: number;
  orderBy?: string;
  ascending?: boolean;
  onlyInView?: boolean;
  createSnapshot?: boolean;
  minLat?: number;
  maxLat?: number;
  minLon?: number;
  maxLon?: number;
}

export interface TargetFromTargetList {
  callSign: string;
  cargoType: string;
  cog: string;
  country: string;
  destination: string;
  draught: string;
  eta: string;
  heading: string;
  imo: string;
  lastAisPositionLat: string;
  lastAisPositionLon: string;
  lastAisReport: string;
  lastAisSatpositionLat: string;
  lastAisSatpositionLon: string;
  lastAisSatreport: string;
  lastAisVesselpositionLat: string;
  lastAisVesselpositionLon: string;
  lastAisVesselreport: string;
  lastLritPositionLat: string;
  lastLritPositionLon: string;
  lastLritReport: string;
  lastRadarPositionLat: string;
  lastRadarPositionLon: string;
  lastRadarReport: string;
  lat: number;
  length: string;
  lon: number;
  mmsi: string;
  name: string;
  navStatus: string;
  posAccuracy: string;
  positionLat: string;
  positionLon: string;
  rot: string;
  shipType: string;
  sog: string;
  sourceType: string;
  type: string;
  width: string;
}

export interface TargetListResponse {
  targets: TargetFromTargetList[];
  timeStamp: string;
  totalShips: number;
}

export const getTargetList = async (
  session: Session,
  params: TargetListParams = {}
): Promise<TargetListResponse> => {
  const defaultParams: TargetListParams = {
    startIndex: 0,
    targetsPerPage: 100,
    orderBy: 'name',
    ascending: true,
    onlyInView: true,
    createSnapshot: true,
  };

  const response = await session.request('getTargetList', {
    ...defaultParams,
    ...params,
  });

  if (!response) {
    return {
      targets: [],
      timeStamp: new Date().toISOString(),
      totalShips: 0,
    };
  }

  return response;
};
